import React, { Component } from "react";
import { connect } from "react-redux";
import LoadingSpinner from "../../../components/LoadingSpinner/index";
import { getUserKasms, getUserImages } from "../../../actions/actionDashboard";
import ListKasms from "./ListKasms";
import { Col, Row, Card, Progress} from "reactstrap";
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";
import Proptypes from "prop-types";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: true},
];

class UserDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            kasmID:""
        };
    }

    componentDidMount() {
        const userInfo = JSON.parse(window.localStorage.user_info);
        const payload_data = {
            "token": userInfo.token,
            "username": userInfo.username
        };
        this.props.kasmsFunc(payload_data);
        this.props.imageFunc(payload_data);
    }

    render() {
        if (this.props.getuserkasmsLoading){
            return (<div> <LoadingSpinner /></div>);
        }

        return (
            <div>
                <BreadCrumbCompo routes={routes}/>
                <Row>
                    <Col sm={{ size: 12, order: 0, offset: 0 }}>
                        <ListKasms kasmID={this.state.kasmID}/>
                    </Col>
                </Row>
            </div>
        );
    }
}


UserDashboard.propTypes = {
    imageFunc: Proptypes.func.isRequired,
    kasmsFunc: Proptypes.func.isRequired,
    liveKasms: Proptypes.array,
    availableKasms: Proptypes.array,
    getuserkasmsLoading: Proptypes.bool,
    history: Proptypes.object.isRequired,
};

function mapStateToProps(state) {
    return {
        isLoggedIn: state.auth.isLoggedIn,
        loginError: state.dashboard.loginError,
        availableKasms: state.dashboard.availableKasms,
        liveKasms: state.dashboard.liveKasms,
        getuserkasmsLoading: state.dashboard.getuserkasmsLoading
    };
}

function mapDispatchToProps(dispatch) {
    return {
        imageFunc: (payload_data) => {dispatch(getUserImages(payload_data));},
        kasmsFunc: (payload_data) => {dispatch(getUserKasms(payload_data));}
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserDashboard);


// WEBPACK FOOTER //
// ./src/views/User/UserDashboard/UserDashboard.js